// extracted by mini-css-extract-plugin
export default {"container":"MiniFaq_container__qDWlO","text":"MiniFaq_text__OId6x","question":"MiniFaq_question__88ANh","answer":"MiniFaq_answer__FI4X6"};